import { Link } from "react-router-dom";
import { MapPin, ArrowRight } from "lucide-react";

export default function PropertyCard({ property, index = 0 }) {
  const formatPrice = (price) => {
    return new Intl.NumberFormat("fr-CH", {
      style: "currency",
      currency: property.currency || "CHF",
      maximumFractionDigits: 0,
    }).format(price);
  };

  const transactionLabel = {
    vente: "À vendre",
    location: "À louer",
    programme: "Programme neuf",
  };

  return (
    <Link
      to={`/biens/${property.id}`}
      data-testid={`property-card-${property.id}`}
      className="property-card group block"
      style={{ animationDelay: `${index * 100}ms` }}
    >
      {/* Image */}
      <div className="relative overflow-hidden aspect-square bg-[#F5F5F5]">
        <img
          src={property.images?.[0] || "https://images.unsplash.com/photo-1600596542815-ffad4c1539a9?w=800"}
          alt={property.title}
          className="property-card-img w-full h-full object-cover"
          loading="lazy"
        />
        {/* Type badge */}
        <div className="absolute top-4 left-4 flex gap-2">
          <span className="font-accent italic text-sm bg-white/90 backdrop-blur-sm px-3 py-1 text-[#333333]">
            {transactionLabel[property.transaction_type] || property.transaction_type}
          </span>
        </div>
        {/* Reference badge */}
        {property.reference && (
          <div className="absolute top-4 right-4">
            <span className="text-[10px] uppercase tracking-wider bg-[#699ab6]/90 backdrop-blur-sm px-2 py-1 text-white font-medium">
              Réf. {property.reference}
            </span>
          </div>
        )}
        {/* Hover overlay */}
        <div className="absolute inset-0 bg-black/0 group-hover:bg-black/10 transition-all duration-700 flex items-end justify-end p-4">
          <div className="opacity-0 group-hover:opacity-100 transition-opacity duration-500">
            <div className="w-10 h-10 rounded-full bg-white flex items-center justify-center">
              <ArrowRight className="w-4 h-4 text-[#333333]" />
            </div>
          </div>
        </div>
      </div>

      {/* Info */}
      <div className="pt-5 pb-2">
        <div className="flex items-center gap-1.5 mb-2">
          <MapPin className="w-3 h-3 text-[#699ab6]" />
          <span className="text-[11px] uppercase tracking-[0.15em] text-[#777777] font-medium">
            {property.location}
          </span>
        </div>
        <h3 className="font-heading text-lg font-medium text-[#333333] leading-snug mb-2 line-clamp-2">
          {property.title}
        </h3>
        <div className="flex items-center justify-between">
          <span className="font-heading text-base font-semibold text-[#699ab6]">
            {property.price ? formatPrice(property.price) : "Prix sur demande"}
          </span>
          <div className="flex items-center gap-3 text-xs text-[#777777]">
            {property.surface && <span>{property.surface} m²</span>}
            {property.rooms && <span>{property.rooms} pièces</span>}
          </div>
        </div>
      </div>
    </Link>
  );
}
